import React, { useState, useEffect } from 'react';
import { stockCountsAPI } from '../services/api';
import Swal from 'sweetalert2';

function StockCount() {
  const [stockCounts, setStockCounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCount, setActiveCount] = useState(null);
  const [countItems, setCountItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchStockCounts();
  }, []);

  const fetchStockCounts = async () => {
    try {
      const response = await stockCountsAPI.getAll();
      setStockCounts(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching stock counts:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถโหลดข้อมูลการนับสต็อกได้',
        confirmButtonColor: '#0ea5e9'
      });
      setLoading(false);
    }
  };

  const startNewCount = async () => {
    const { value: formValues } = await Swal.fire({
      title: 'เริ่มการนับสต็อกใหม่',
      html:
        '<input id="count_date" type="date" class="swal2-input" value="' + new Date().toISOString().split('T')[0] + '">' +
        '<textarea id="notes" class="swal2-textarea" placeholder="หมายเหตุ (ถ้ามี)"></textarea>',
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'เริ่มนับสต็อก',
      cancelButtonText: 'ยกเลิก',
      confirmButtonColor: '#0ea5e9',
      preConfirm: () => {
        return {
          count_date: document.getElementById('count_date').value,
          notes: document.getElementById('notes').value
        };
      }
    });

    if (formValues) {
      try {
        const response = await stockCountsAPI.create(formValues);
        Swal.fire({
          icon: 'success',
          title: 'สร้างการนับสต็อกสำเร็จ',
          text: `เพิ่มสินค้า ${response.data.product_count} รายการ`,
          confirmButtonColor: '#0ea5e9'
        });
        fetchStockCounts();
      } catch (error) {
        console.error('Error creating stock count:', error);
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่สามารถสร้างการนับสต็อกได้',
          confirmButtonColor: '#0ea5e9'
        });
      }
    }
  };

  const openCount = async (count) => {
    try {
      const response = await stockCountsAPI.getById(count.id);
      setActiveCount(response.data);
      setCountItems(response.data.items);
    } catch (error) {
      console.error('Error loading stock count:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถโหลดข้อมูลการนับสต็อกได้',
        confirmButtonColor: '#0ea5e9'
      });
    }
  };

  const exportToHTML = () => {
    if (!activeCount || !countItems || countItems.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'ไม่มีข้อมูล',
        text: 'ไม่มีข้อมูลให้ส่งออก',
        confirmButtonColor: '#0ea5e9'
      });
      return;
    }

    const htmlContent = `
<!DOCTYPE html>
<html lang="th">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>ใบนับสต็อก - ${new Date(activeCount.count_date).toLocaleDateString('th-TH')}</title>
  <style>
    @media print {
      @page { margin: 1cm; }
      body { margin: 0; }
      .no-print { display: none; }
    }
    body {
      font-family: 'Sarabun', Arial, sans-serif;
      margin: 20px;
      font-size: 14px;
    }
    .header {
      text-align: center;
      margin-bottom: 20px;
      border-bottom: 2px solid #333;
      padding-bottom: 10px;
    }
    .header h1 {
      margin: 0;
      font-size: 24px;
    }
    .info {
      margin-bottom: 20px;
    }
    .info p {
      margin: 5px 0;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 10px;
    }
    th, td {
      border: 1px solid #333;
      padding: 8px;
      text-align: left;
    }
    th {
      background-color: #f0f0f0;
      font-weight: bold;
      text-align: center;
    }
    .center { text-align: center; }
    .count-box {
      width: 80px;
      min-height: 30px;
      border-bottom: 1px solid #999;
      display: inline-block;
    }
    .footer {
      margin-top: 30px;
      padding-top: 20px;
      border-top: 1px solid #ccc;
    }
    .signature {
      margin-top: 40px;
      display: flex;
      justify-content: space-around;
    }
    .signature div {
      text-align: center;
    }
    .signature-line {
      width: 200px;
      border-bottom: 1px solid #333;
      margin: 40px auto 10px;
    }
    .no-print {
      text-align: center;
      margin: 20px 0;
    }
    .no-print button {
      background-color: #0ea5e9;
      color: white;
      border: none;
      padding: 12px 24px;
      font-size: 16px;
      border-radius: 6px;
      cursor: pointer;
      margin: 0 5px;
    }
    .no-print button:hover {
      background-color: #0284c7;
    }
  </style>
</head>
<body>
  <div class="no-print">
    <button onclick="window.print()">🖨️ พิมพ์</button>
    <button onclick="window.close()">✕ ปิด</button>
  </div>

  <div class="header">
    <h1>ใบนับสต็อกสินค้า</h1>
    <p>Stock Count Sheet</p>
  </div>

  <div class="info">
    <p><strong>วันที่นับ:</strong> ${new Date(activeCount.count_date).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
    <p><strong>เลขที่:</strong> SC-${String(activeCount.id).padStart(5, '0')}</p>
    ${activeCount.notes ? `<p><strong>หมายเหตุ:</strong> ${activeCount.notes}</p>` : ''}
  </div>

  <table>
    <thead>
      <tr>
        <th style="width: 50px;">ลำดับ</th>
        <th style="width: 120px;">บาร์โค้ด</th>
        <th>ชื่อสินค้า</th>
        <th style="width: 100px;" class="center">สต็อกในระบบ</th>
        <th style="width: 100px;" class="center">จำนวนที่นับได้</th>
        <th style="width: 150px;">หมายเหตุ</th>
      </tr>
    </thead>
    <tbody>
      ${countItems.map((item, index) => `
        <tr>
          <td class="center">${index + 1}</td>
          <td>${item.barcode || '-'}</td>
          <td>${item.product_name}</td>
          <td class="center">${item.system_quantity}</td>
          <td class="center"><span class="count-box"></span></td>
          <td></td>
        </tr>
      `).join('')}
    </tbody>
  </table>

  <div class="footer">
    <p><strong>จำนวนรายการทั้งหมด:</strong> ${countItems.length} รายการ</p>
  </div>

  <div class="signature">
    <div>
      <div class="signature-line"></div>
      <p>ผู้นับสต็อก</p>
      <p>วันที่: _______________</p>
    </div>
    <div>
      <div class="signature-line"></div>
      <p>ผู้ตรวจสอบ</p>
      <p>วันที่: _______________</p>
    </div>
  </div>
</body>
</html>
    `.trim();

    const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `stock_count_sheet_${activeCount.id}_${new Date().toISOString().split('T')[0]}.html`;
    link.click();

    Swal.fire({
      icon: 'success',
      title: 'ส่งออกสำเร็จ',
      text: 'ไฟล์ HTML ถูกส่งออกเรียบร้อยแล้ว สามารถเปิดไฟล์แล้วพิมพ์ได้เลย',
      confirmButtonColor: '#0ea5e9',
      timer: 3000
    });
  };

  const exportToCSV = () => {
    if (!activeCount || !countItems || countItems.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'ไม่มีข้อมูล',
        text: 'ไม่มีข้อมูลให้ส่งออก',
        confirmButtonColor: '#0ea5e9'
      });
      return;
    }

    const headers = ['ลำดับ', 'ชื่อสินค้า', 'บาร์โค้ด', 'จำนวนในระบบ', 'จำนวนที่นับได้', 'ผลต่าง', 'หมายเหตุ'];
    const rows = countItems.map((item, index) => {
      const difference = item.counted_quantity - item.system_quantity;
      return [
        index + 1,
        item.product_name || '-',
        item.barcode || '-',
        item.system_quantity,
        item.counted_quantity,
        difference > 0 ? `+${difference}` : difference,
        item.notes || '-'
      ];
    });

    // Add summary
    const totalDifference = countItems.reduce((sum, item) => sum + (item.counted_quantity - item.system_quantity), 0);
    const summaryRows = [
      ['การนับสต็อก'],
      [`วันที่: ${new Date(activeCount.count_date).toLocaleDateString('th-TH')}`],
      [`สถานะ: ${activeCount.status === 'completed' ? 'เสร็จสิ้น' : 'กำลังดำเนินการ'}`],
      [`หมายเหตุ: ${activeCount.notes || '-'}`],
      [],
      headers,
      ...rows,
      [],
      ['สรุป'],
      ['จำนวนรายการทั้งหมด', countItems.length],
      ['ผลต่างรวม', totalDifference > 0 ? `+${totalDifference}` : totalDifference]
    ];

    const csvContent = summaryRows
      .map(row => row.map(cell => `"${cell}"`).join(','))
      .join('\r\n');

    // Create UTF-8 BOM for Thai character support
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `stock_count_${activeCount.id}_${new Date().toISOString().split('T')[0]}.csv`;
    link.click();

    Swal.fire({
      icon: 'success',
      title: 'ส่งออกสำเร็จ',
      text: 'ไฟล์ CSV ถูกส่งออกเรียบร้อยแล้ว',
      confirmButtonColor: '#0ea5e9',
      timer: 2000
    });
  };

  const updateCountedQuantity = async (item, newQuantity) => {
    if (activeCount.status === 'completed') {
      Swal.fire({
        icon: 'warning',
        title: 'ไม่สามารถแก้ไขได้',
        text: 'การนับสต็อกนี้เสร็จสิ้นแล้ว',
        confirmButtonColor: '#0ea5e9'
      });
      return;
    }

    try {
      await stockCountsAPI.updateItem(activeCount.id, item.id, {
        counted_quantity: parseInt(newQuantity),
        notes: item.notes
      });

      // Update local state
      setCountItems(prevItems =>
        prevItems.map(i =>
          i.id === item.id
            ? { ...i, counted_quantity: parseInt(newQuantity) }
            : i
        )
      );
    } catch (error) {
      console.error('Error updating counted quantity:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถอัพเดทจำนวนได้',
        confirmButtonColor: '#0ea5e9'
      });
    }
  };

  const completeCount = async () => {
    const result = await Swal.fire({
      title: 'ยืนยันการเสร็จสิ้นการนับสต็อก',
      html: `
        <p class="mb-2">การนับสต็อกจะถูกปิด และระบบจะปรับปรุงสต็อกตามจำนวนที่นับได้</p>
        <p class="text-red-600 font-bold">⚠️ คุณไม่สามารถแก้ไขได้หลังจากยืนยัน</p>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
      confirmButtonColor: '#0ea5e9',
      cancelButtonColor: '#ef4444'
    });

    if (result.isConfirmed) {
      try {
        const response = await stockCountsAPI.complete(activeCount.id);
        Swal.fire({
          icon: 'success',
          title: 'เสร็จสิ้นการนับสต็อก',
          html: `
            <p>ปรับปรุงสต็อก ${response.data.adjusted_items} รายการ</p>
            <p>จากทั้งหมด ${response.data.total_items} รายการ</p>
          `,
          confirmButtonColor: '#0ea5e9'
        });
        setActiveCount(null);
        setCountItems([]);
        fetchStockCounts();
      } catch (error) {
        console.error('Error completing stock count:', error);
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่สามารถเสร็จสิ้นการนับสต็อกได้',
          confirmButtonColor: '#0ea5e9'
        });
      }
    }
  };

  const deleteCount = async (count) => {
    if (count.status === 'completed') {
      Swal.fire({
        icon: 'warning',
        title: 'ไม่สามารถลบได้',
        text: 'ไม่สามารถลบการนับสต็อกที่เสร็จสิ้นแล้ว',
        confirmButtonColor: '#0ea5e9'
      });
      return;
    }

    const result = await Swal.fire({
      title: 'ยืนยันการลบ',
      text: 'คุณต้องการลบการนับสต็อกนี้หรือไม่?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'ลบ',
      cancelButtonText: 'ยกเลิก',
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#6b7280'
    });

    if (result.isConfirmed) {
      try {
        await stockCountsAPI.delete(count.id);
        Swal.fire({
          icon: 'success',
          title: 'ลบสำเร็จ',
          confirmButtonColor: '#0ea5e9'
        });
        fetchStockCounts();
      } catch (error) {
        console.error('Error deleting stock count:', error);
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่สามารถลบการนับสต็อกได้',
          confirmButtonColor: '#0ea5e9'
        });
      }
    }
  };

  const filteredItems = countItems.filter(item =>
    item.product_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.barcode && item.barcode.includes(searchTerm))
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-xl">กำลังโหลด...</div>
      </div>
    );
  }

  if (activeCount) {
    const totalDifference = countItems.reduce((sum, item) => {
      return sum + (item.counted_quantity - item.system_quantity);
    }, 0);

    return (
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">
              การนับสต็อก - {new Date(activeCount.count_date).toLocaleDateString('th-TH')}
            </h1>
            <p className="text-gray-600 mt-1">
              สถานะ: <span className={`font-bold ${activeCount.status === 'completed' ? 'text-green-600' : 'text-yellow-600'}`}>
                {activeCount.status === 'completed' ? 'เสร็จสิ้น' : 'กำลังดำเนินการ'}
              </span>
            </p>
          </div>
          <div className="flex gap-2">
            <button
              onClick={exportToHTML}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-semibold flex items-center gap-2"
            >
              <span>🖨️</span>
              ส่งออกใบนับสต็อก (HTML)
            </button>
            <button
              onClick={exportToCSV}
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-semibold flex items-center gap-2"
            >
              <span>📥</span>
              ส่งออก CSV
            </button>
            {activeCount.status === 'in_progress' && (
              <button
                onClick={completeCount}
                className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-semibold"
              >
                ✓ เสร็จสิ้นการนับสต็อก
              </button>
            )}
            <button
              onClick={() => {
                setActiveCount(null);
                setCountItems([]);
              }}
              className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-2 rounded-lg font-semibold"
            >
              ← กลับ
            </button>
          </div>
        </div>

        {/* Summary */}
        <div className="bg-white rounded-lg shadow p-4 mb-6">
          <div className="grid grid-cols-3 gap-4 text-center">
            <div>
              <div className="text-2xl font-bold text-primary-600">{countItems.length}</div>
              <div className="text-sm text-gray-600">รายการทั้งหมด</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-gray-800">
                {countItems.filter(i => i.counted_quantity !== i.system_quantity).length}
              </div>
              <div className="text-sm text-gray-600">รายการมีความแตกต่าง</div>
            </div>
            <div>
              <div className={`text-2xl font-bold ${totalDifference > 0 ? 'text-green-600' : totalDifference < 0 ? 'text-red-600' : 'text-gray-600'}`}>
                {totalDifference > 0 ? '+' : ''}{totalDifference}
              </div>
              <div className="text-sm text-gray-600">ผลต่างรวม</div>
            </div>
          </div>
        </div>

        {/* Search */}
        <div className="mb-4">
          <input
            type="text"
            placeholder="ค้นหาสินค้า (ชื่อ หรือบาร์โค้ด)..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
        </div>

        {/* Items Table */}
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">ลำดับ</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">บาร์โค้ด</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">ชื่อสินค้า</th>
                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">สต็อกในระบบ</th>
                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">จำนวนที่นับได้</th>
                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">ผลต่าง</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredItems.map((item, index) => {
                  const difference = item.counted_quantity - item.system_quantity;
                  return (
                    <tr key={item.id} className={difference !== 0 ? 'bg-yellow-50' : ''}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {index + 1}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        {item.barcode || '-'}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-900">
                        {item.product_name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-center text-gray-900">
                        {item.system_quantity}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <input
                          type="number"
                          min="0"
                          value={item.counted_quantity}
                          onChange={(e) => updateCountedQuantity(item, e.target.value)}
                          disabled={activeCount.status === 'completed'}
                          className="w-24 p-2 border rounded text-center focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:bg-gray-100"
                        />
                      </td>
                      <td className={`px-6 py-4 whitespace-nowrap text-sm text-center font-bold ${
                        difference > 0 ? 'text-green-600' :
                        difference < 0 ? 'text-red-600' :
                        'text-gray-600'
                      }`}>
                        {difference > 0 ? '+' : ''}{difference}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">การนับสต็อก</h1>
        <button
          onClick={startNewCount}
          className="bg-primary-600 hover:bg-primary-700 text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2"
        >
          <span className="text-xl">+</span>
          เริ่มการนับสต็อกใหม่
        </button>
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">วันที่นับ</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">ผู้สร้าง</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">จำนวนรายการ</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">สถานะ</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">จัดการ</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {stockCounts.length === 0 ? (
              <tr>
                <td colSpan="5" className="px-6 py-12 text-center text-gray-500">
                  ยังไม่มีการนับสต็อก
                </td>
              </tr>
            ) : (
              stockCounts.map((count) => (
                <tr key={count.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {new Date(count.count_date).toLocaleDateString('th-TH')}
                    </div>
                    <div className="text-xs text-gray-500">
                      สร้างเมื่อ {new Date(count.created_at).toLocaleString('th-TH')}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {count.created_by_name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-900">
                    {count.item_count || 0}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                    <span className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      count.status === 'completed'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-yellow-100 text-yellow-800'
                    }`}>
                      {count.status === 'completed' ? 'เสร็จสิ้น' : 'กำลังดำเนินการ'}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                    <button
                      onClick={() => openCount(count)}
                      className="text-primary-600 hover:text-primary-900 mr-3"
                    >
                      {count.status === 'completed' ? 'ดูรายละเอียด' : 'ดำเนินการต่อ'}
                    </button>
                    {count.status !== 'completed' && (
                      <button
                        onClick={() => deleteCount(count)}
                        className="text-red-600 hover:text-red-900"
                      >
                        ลบ
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default StockCount;
